import { render, staticRenderFns } from "./step_2.vue?vue&type=template&id=16aced1c&scoped=true&lang=pug&"
import script from "./step_2.vue?vue&type=script&lang=js&"
export * from "./step_2.vue?vue&type=script&lang=js&"
import style0 from "./step_2.vue?vue&type=style&index=0&id=16aced1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aced1c",
  null
  
)

export default component.exports